import CustomSelect from '../../form/CustomSelect';
import { GB, TH } from 'country-flag-icons/react/3x2';
import { useDict, useLanguageUpdate } from '../../../contexts/LanguageContext';
import { Field, withTypes } from 'react-final-form';
import { postUpdateUserLanguage } from '../src/languageToggleApis';

const LanguageToggle = (props) => {
    const { selectClassName, formClassName, formDivClassName } = props;

    const dict = useDict();
    const toggleLanguage = useLanguageUpdate();

    const languages = [
        {
            value: 'th',
            label: (
                <>
                    <TH title="Thai" className="flag-icon" /> {dict.thai}
                </>
            ),
        },
        {
            value: 'en',
            label: (
                <>
                    <GB title="English" className="flag-icon" /> {dict.english}
                </>
            ),
        },
    ];

    const { Form } = withTypes();

    const handlePostUpdateUserLanguage = (response) => {
        toggleLanguage(response.locale);
    };

    const updateUserLanguage = (values) => {
        postUpdateUserLanguage({locale: values}, handlePostUpdateUserLanguage);
    };

    return (
        <Form
            initialValues={{
                language:
                    localStorage.getItem('language') === 'en' ? 'en' : 'th',
            }}
            onSubmit
        >
            {({ handleSubmit, values }) => (
                <form
                    className={`form ${formClassName}`}
                    onSubmit={handleSubmit}
                >
                    <div className={`form__form-group ${formDivClassName}`}>
                        <div className="form__form-group">
                            <div className="form__form-group-field">
                                <Field name="language">
                                    {({ input, meta }) => (
                                        <CustomSelect
                                            input={input}
                                            meta={meta}
                                            options={languages}
                                            onChange={(value) => {
                                                updateUserLanguage(value?.value);
                                            }}
                                            data-cy="sidebar__language"
                                            height="40px"
                                            border="1px solid #dddddd"
                                            selectClassName={selectClassName}
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                    </div>
                </form>
            )}
        </Form>
    );
};

export default LanguageToggle;
